// extracted by mini-css-extract-plugin
export default {"typeContainer":"Rarity_typeContainer__c-yJr","checkBoxItem":"Rarity_checkBoxItem__0OlRv","checkBox":"Rarity_checkBox__hwTV3"};